<template>
    <el-container style="width:100%">
        <el-header>
            <td-permission :permissions="permissionsView">
                <div slot="havePermission">
                    <el-form :inline="true" :model="formRole" ref="formRole" class="demo-form-inline" @submit.native.prevent>
                        <el-row>
                            <el-form-item :label="$t('common.ROLENAME')" prop="RoleName">
                                <td-input v-model="formRole.RoleName" @keyup.enter.native="btnQuery"></td-input>
                            </el-form-item>
                            <el-form-item class="menuStyle">
                                <td-button @click="btnQuery" :loading="loading" type="primary">{{ $t('common.QUERY') }}</td-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </td-permission>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :dataSource="tableData"
                :permissions="permissionsView"
                :columns="columns"
                :rowKey="rowKey"
                :hasIndex="hasIndex"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="hasMutiSelect"
                :hasPage="hasPage"
                :hasLoading="hasLoading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
        </el-main>
    </el-container>
</template>
<script>
import api from './assets/api.js';
export default {
    components: {},
    data() {
        return {
            formRole: {
                RoleName: ''
            },
            hasIndex: true,
            permissionsView: ['workflow:view'],
            hasMutiSelect: false,
            hasPage: true,
            loading: false,
            dialogRoleVisible: false,
            title: '',
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            hasLoading: false,
            rowKey: 'id',
            columns: [
                {
                    label: 'common.ROLENAME',
                    prop: 'roleName',
                    align: 'center'
                },
                {
                    label: 'common.DESCRIPTION',
                    prop: 'description',
                    align: 'center'
                }
            ],
            tableData: [],
            // 对表单进行数据验证
            rules: {
                RoleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            }
        };
    },
    mounted() {
        this.btnQuery();
    },
    methods: {
        /* 角色信息查询 */
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            this.loading = true;
            let param = {
                RoleName: this.formRole.RoleName,
                lockState: this.formRole.lockState,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            api.listRoleInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('workFlowAuthor/listRoleInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('workFlowAuthor/listRoleInfo', response.data.message);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        RoleDialogClose() {
            this.dialogRoleVisible = false;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        }
    }
};
</script>
<style>
.menuStyle {
    padding-left: 100px;
}
</style>
